import { getPfmInstance } from '@shared/api';

export const TownsToAPI = {
  getTownsTo(countryToId: number, townFromId: number) {
    const pfm = getPfmInstance();
    return pfm.tourflow.getTownsTo(townFromId, countryToId);
  },
};
